export default __webpack_public_path__ + "static/media/The_Nest_large_13.11942ef7.jpg";